import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, Outlet } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { ChevronLeft, X, ChevronBarLeft, ChevronBarRight } from 'react-bootstrap-icons';
import './Base.scss';
import { getPermissionState, isSuperAdmin } from '../../utils/functions';
import Modal from 'react-bootstrap/Modal';
import { FaWhatsapp, FaHeadset, FaGraduationCap } from 'react-icons/fa6';
import { FaChevronRight, FaShieldAlt } from 'react-icons/fa';
import { localDB } from '../../crud/localDB/localDB';

////// IMPORT TYPES
import { menuObjectAdmin, menuObjectMobile, MenuOption, getVisibleMenuObject } from './Routes';
import { getLastLocalSessionByLocalId } from '../../crud/management_api/local_sessions';
import { LocalSession } from '../../types/LocalSession';

import { PedidosProvider } from '../Restaurant/Pedidos/PedidosContext';

//////////// SUBCOMPONENTES //////////
import Panel from './components/Panel/Panel';
import HeaderLogo from './components/HeaderLogo/HeaderLogo';
import NoAuth from './components/NoAuth/NoAuth';
import NavBar from './components/NavBar/NavBar';
import Ciao from '../../components/Ciao/Ciao';

//////// COMPONENTES QUE SE RUTEARAN //////////
import Usuarios from '../Restaurant/Configuracion/Usuarios/Usuarios';
import Menu from '../Restaurant/Menu/Menu/PaginaMenu';
import Items from '../Restaurant/Menu/Items/Items';
import Categorys from '../Restaurant/Menu/Categories/Categories';
import Ingredients from '../Restaurant/Menu/Ingredients/Ingredients';
import SelectionGroups from '../Restaurant/Menu/SelectionGroups/SelectionGroups';
import SelectionModifiers from '../Restaurant/Menu/SelectionModifiers/SelectionModifiers';
import PaginaSalones from '../Restaurant/Configuracion/Salones/PaginaSalones';
import Workstations from '../Restaurant/Configuracion/Workstations/Workstations';
import Puestos from '../Restaurant/Configuracion/Puestos/Puestos';
import Providers from '../Restaurant/Gestion/Providers/Providers';
import Terminal from '../Restaurant/Configuracion/Terminals/Terminals';
import Integrations from 'views/Restaurant/Configuracion/Integrations/Integrations';
import UserProfile from './components/UserProfile/UserProfile';
import Restaurant from '../Restaurant/Pedidos/Restaurant/RestaurantV2';
import PedidosConfig from '../Restaurant/Pedidos/PedidosConfig/PedidosConfig';
import VentaCaja from '../Restaurant/Pedidos/VentaCaja/VentaCaja';
import TipManagement from '../Restaurant/Caja/TipManagement/TipManagement';
import HistorialPedidos from '../Restaurant/Pedidos/HistorialPedidos/HistorialPedidos';
import CuponesDescuentos from '../Restaurant/ClientManagement/CuponesDescuentos/CuponesDescuentos';
import AjustesPermisos from '../Restaurant/Configuracion/AjustesPermisos/AjustesPermisos';
import DelegatedSettings from '../Restaurant/Configuracion/AjustesPermisos/components/DelegatedSettings';
import { useSettingsDelegationAccess } from './useSettingsDelegationAccess';
import { isFeatureRolloutLocal } from '../../configuration/directMenuRollout';
import { settingsMessages } from '../../configuration/settingsDelegation';
import ModificacionesPedidos from '../Restaurant/Gestion/PedidosModifications/PedidosModifications';
import PriceModifications from '../Restaurant/Gestion/PriceModifications/PriceModifications';
import Recommendations from './components/Recommendations/Recommendations';
import Delivery from '../Restaurant/Pedidos/Delivery/Delivery';
import ReceiptsDisplay from '../Restaurant/Caja/Receipts/ReceiptsDisplay';
import CajasManagement from '../Restaurant/Caja/CajasManagement/CajasManagement';
import Ventas from '../Restaurant/Caja/Ventas/Ventas';
import Transactions from '../Restaurant/Caja/Transactions/Transactions';
import ReviewsSummary from '../Restaurant/ClientManagement/Reviews/ReviewsSummary';
import ReservationManagement from '../Restaurant/ClientManagement/ReservationManagement/ReservationManagement';
import OnlineMenuManagement from '../Restaurant/ClientManagement/OnlineMenuManagement/OnlineMenuManagement';
import Clients from 'views/Restaurant/ClientManagement/Clients/Clients';
import Gastos from '../Restaurant/Gestion/Compras/Compras';
import StorageUnits from '../Restaurant/Gestion/StorageUnits/StorageUnits';
import Bills from '../Restaurant/Gestion/Bills/Bills';
import Salario from '../Restaurant/Gestion/Salarios/Salarios';
import Stock from '../Restaurant/Gestion/Stock/Stock';

////////////// COMPONENTES DE ADMIN ///////////

import { toast } from 'react-toastify';


// A tiny “layout” that just provides the PedidosProvider to its children
function PedidosLayout() {
  return (
    <PedidosProvider>
      <Outlet />
    </PedidosProvider>
  );
}

const Base: React.FC = () => {
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // Desktop sidebar collapsed state
  const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);
  const [openModalSoporte, setOpenModalSoporte] = useState(false);
  const navigate = useNavigate();
  
  // Check if user is admin from user object (only for showing Portal Administrador button)
  const userJson = localStorage.getItem('user');
  const isAdmin = userJson ? JSON.parse(userJson).is_admin === true : false;
  const currentUser = userJson ? JSON.parse(userJson) : {};
  const settingsAccess = useSettingsDelegationAccess(currentUser.local_id, currentUser.user_id, isSuperAdmin());
  
   const visibleMenu = React.useMemo(
   () => getVisibleMenuObject(getPermissionState, isSuperAdmin, settingsAccess.read),
   [settingsAccess.read]
 );
 const globalMenuOption = visibleMenu;

 const visibleMenuMobile = React.useMemo(() => {
   const base = getVisibleMenuObject(getPermissionState, isSuperAdmin, settingsAccess.read);
   return [menuObjectMobile[0], ...base];
 }, [settingsAccess.read]);
 const globalMenuOptionMobile = visibleMenuMobile;
  const [lastSession, setLastSession] = useState<LocalSession | null>(null);

  // Load sidebar collapsed state from localDB on mount
  useEffect(() => {
    localDB.get<boolean>('ui', 'sidebarExpanded').then(saved => {
      if (saved !== null) {
        setIsSidebarCollapsed(!saved); // sidebarExpanded true means collapsed false
      }
      // If null, keep default (false = expanded)
    }).catch(err => {
      console.error('Error loading sidebar state from localDB:', err);
    });
  }, []);

  useEffect(()=>
  {
    const user = localStorage.getItem('user');
    const local_id = user ? Number(JSON.parse(user).local_id) : 0;
    getLastLocalSessionByLocalId(local_id)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setLastSession(response.data);
        } else {
          toast.error('No se pudo obtener la última sesión local.');
        }
      }
      )
      .catch((error) => {
        console.error('Error obteniendo datos de sesión:', error);
      });
  }, []);


  const toggleMenu = async (menu: MenuOption) => {
    if (!menu.suboptions || menu.suboptions.length === 0) {
      if (menu.route) {
        navigate(menu.route);
        setIsSidebarOpen(false); // Cierra el sidebar al seleccionar una opción principal
      }
      return;
    }
    
    // Si el sidebar está colapsado y hay submenús, expandir automáticamente
    if (isSidebarCollapsed) {
      setIsSidebarCollapsed(false);
      try {
        await localDB.set('ui', 'sidebarExpanded', true);
      } catch (err) {
        console.error('Error saving sidebar state to localDB:', err);
      }
    }
    
    setOpenMenu(openMenu === menu.name ? null : menu.name);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleSidebarCollapse = async () => {
    const newCollapsedState = !isSidebarCollapsed;
    setIsSidebarCollapsed(newCollapsedState);
    
    // Save to localDB (sidebarExpanded is the inverse of collapsed)
    try {
      await localDB.set('ui', 'sidebarExpanded', !newCollapsedState);
    } catch (err) {
      console.error('Error saving sidebar state to localDB:', err);
    }
  };

  const handleSubMenuClick = (sub: any) => {
    setActiveSubMenu(sub.name);
    if (sub.route) {
      navigate(sub.route);
      setIsSidebarOpen(false); // Cierra el sidebar al seleccionar una subopción
    }
  };

const renderMobileMenu = () => (
  <div className={`mobile-menu ${isSidebarOpen ? 'open' : ''}`}>
    <button className="menu-close-button" onClick={toggleSidebar}>
      <ChevronLeft /> Volver
    </button>
    <ul>
      {globalMenuOptionMobile.map((menu) => {
        const Icon = menu.icon;
        return (
          <li key={menu.name}>
            <a onClick={() => {
              toggleMenu(menu);
              if (menu.name === 'Inicio') setIsSidebarOpen(false); // Cierra el sidebar si es Inicio
            }}>
              {Icon && <Icon style={{ marginRight: 8 }} />}
              {menu.name}
            </a>
            {menu.suboptions && menu.suboptions.length > 0 && (
              <ul className={`collapse ${openMenu === menu.name ? 'show' : ''}`}>
                {menu.suboptions.map((sub) => {
                  const SubIcon = sub.icon!;
                  return (
                    <li key={sub.name} className={activeSubMenu === sub.name ? 'active' : ''}>
                      <a onClick={() => handleSubMenuClick(sub)}>
                        <FaChevronRight className="submenu-chevron" />
                        {SubIcon && <SubIcon style={{ marginRight: 6 }} />}
                        {sub.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
      {isAdmin && (
        <li style={{display:'flex',justifyContent: 'center', marginTop: 16}}>
          <Button 
            onClick={() => navigate('/MedioPuntoAdmin')} 
            variant='none' 
            className="admin-portal-button-mobile"
          >
            <FaShieldAlt style={{ marginRight: 8, fontSize: '1.1rem' }} />
            Portal Administrador
          </Button>
        </li>
      )}
      <li style={{display:'flex',justifyContent: 'center', marginTop: isAdmin ? 8 : 16}}>
        <Button 
          onClick={() => setOpenModalSoporte(true)} 
          variant='none' 
          className="support-button-mobile"
        >
          <FaHeadset style={{ marginRight: 8, fontSize: '1.1rem' }} />
          Soporte
        </Button>
      </li>
    </ul>
  </div>
);


const renderSideBarLinks = () => (
  <ul className="list-unstyled components">
    {globalMenuOption.map((menu) => {
      const Icon = menu.icon;
      return (
        <li key={menu.name} className={openMenu === menu.name ? 'active' : ''}>
          <a onClick={() => toggleMenu(menu)}>
            {Icon && <Icon style={{ marginRight: 8 }} />}
            {menu.name}
          </a>
          {menu.suboptions && menu.suboptions.length > 0 && (
            <ul className={`collapse list-unstyled ${openMenu === menu.name ? 'show' : ''}`}>
              {menu.suboptions.map((sub) => {
                const SubIcon = sub.icon!;
                return (
                  <li key={sub.name} className={activeSubMenu === sub.name ? 'active' : ''}>
                    <a onClick={() => handleSubMenuClick(sub)}>
                      <FaChevronRight className="submenu-chevron" />
                      {SubIcon && <SubIcon style={{ marginRight: 6 }} />}
                      {sub.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      );
    })}
  </ul>
);


const ModalSoporte = ({ onHide }: { onHide: () => void }) => {

  // Abrir WhatsApp con el número
  const handleWhatsapp = () => {
    const phone = '56927057083';
    window.open(`https://wa.me/${phone}`, '_blank');
  };

  return (
    <Modal show={true} onHide={onHide} className='modal-soporte'>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">
            Soporte
          </Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p className="support-modal-subtitle">¿En qué podemos ayudarte?</p>
        <div className='support-options-container'>
          <div className='support-option-card' onClick={handleWhatsapp}>
            <div className='support-icon-container'>
              <FaWhatsapp className="support-icon" />
            </div>
            <div className='support-option-content'>
              <h5 className='support-option-title'>Contacto directo</h5>
              <p className='support-option-description'>Chatea con nuestro equipo de soporte</p>
            </div>
          </div>
          
          <div 
            className='support-option-card' 
            onClick={() => {
              window.open('/Tutorials', '_blank');
              onHide();
            }}
          >
            <div className='support-icon-container'>
              <FaGraduationCap className="support-icon" />
            </div>
            <div className='support-option-content'>
              <h5 className='support-option-title'>Tutoriales y Preguntas Frecuentes</h5>
              <p className='support-option-description'>Aprende con nuestras guías y videos</p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="form-modal-footer-custom">
        <Button variant="none" className='form-button-cancel' onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const handleSoporte = () => {
  const message = 'Ayuda!⚠️ , tengo un problema con :\n\n';
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wkf.ms/43AVUEp?text=${encodedMessage}`, '_blank');
};


  return (
    <>
    <div className={`wrapper ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {renderMobileMenu()}
      <nav id="sidebar" className={`sidebar-container ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <HeaderLogo isCollapsed={isSidebarCollapsed} />
        </div>
        {renderSideBarLinks()}
        <ul className="inmediate-actions-container">
          {isAdmin && (
            <li>
              <Button 
                onClick={() => navigate('/MedioPuntoAdmin')} 
                variant='none' 
                className="admin-portal-button-desktop"
              >
                <FaShieldAlt style={{ marginRight: isSidebarCollapsed ? 0 : 8, fontSize: '1.1rem' }} />
                {!isSidebarCollapsed && 'Portal Administrador'}
              </Button>
            </li>
          )}
          <li>
            <Button 
              onClick={() => setOpenModalSoporte(true)} 
              variant='none' 
              className="support-button-desktop"
            >
              <FaHeadset style={{ marginRight: isSidebarCollapsed ? 0 : 8, fontSize: '1.1rem' }} />
              {!isSidebarCollapsed && 'Soporte'}
            </Button>
          </li>
          <li>
            <Button 
              onClick={toggleSidebarCollapse} 
              variant='none' 
              className="collapse-toggle-button"
              title={isSidebarCollapsed ? 'Expandir menú' : 'Colapsar menú'}
            >
              {isSidebarCollapsed ? <ChevronBarRight size={20} /> : <ChevronBarLeft size={20} />}
            </Button>
          </li>
        </ul>
      </nav>

      <div id="content" className="mediopunto-content">
        <NavBar 
        isSidebarOpen={isSidebarOpen} 
        setIsSidebarOpen={setIsSidebarOpen} 
        lastSession={lastSession}
        setLastSession={setLastSession}
        />

        {openModalSoporte && (
          <ModalSoporte onHide={() => setOpenModalSoporte(false)} />
        )}

        <div className="main-content">
            <Routes>
            <Route path="/" element={<Panel />} />
            <Route path="/CajasManagement" element={ getPermissionState(1) ? <CajasManagement lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/Ventas" element={getPermissionState(4) ? <Ventas lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/UserProfile" element={<UserProfile />} />
            <Route path="/Transactions" element={getPermissionState(57) ? <Transactions lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/Menus/:menuId?/:categoryId?" element={getPermissionState(15) ? <Menu /> : <NoAuth />} />
            <Route path="/Categories" element={getPermissionState(18) ? <Categorys /> : <NoAuth />} />
            <Route path="/Items/:category_id?" element={getPermissionState(20) ? <Items /> : <NoAuth />} />
            <Route path="/Ingredients" element={getPermissionState(22) ? <Ingredients /> : <NoAuth />} />
            <Route path="/SelectionGroups" element={getPermissionState(66) ? <SelectionGroups /> : <NoAuth />} /> 
            <Route path="/SelectionModifiers" element={getPermissionState(66) ? <SelectionModifiers /> : <NoAuth />} />
            <Route path="/PaginaSalones" element={getPermissionState(62) ? <PaginaSalones /> : <NoAuth />} />
            <Route path="/Usuarios" element={isSuperAdmin() ? <Usuarios /> : <NoAuth />} />
            <Route path="/Workstations" element={getPermissionState(45) ? <Workstations /> : <NoAuth />} />
            <Route path="/Puestos" element={getPermissionState(43) ? <Puestos /> : <NoAuth />} />
            <Route path="/Providers" element={getPermissionState(34) ? <Providers /> : <NoAuth />} />
            <Route path="/Terminals" element={getPermissionState(49) ? <Terminal /> : <NoAuth />} />
            <Route path="/CuponesDescuentos" element={getPermissionState(29) ? <CuponesDescuentos /> : <NoAuth />} /> 
            <Route path="/AjustesPermisos" element={isSuperAdmin() ? <AjustesPermisos /> :
              settingsAccess.read ? <DelegatedSettings key={currentUser.local_id}
                localId={currentUser.local_id} canEdit={settingsAccess.edit} /> :
              isFeatureRolloutLocal(currentUser.local_id) && settingsAccess.status === 'loading'
                ? <p role="status">{settingsMessages.loading}</p> :
              isFeatureRolloutLocal(currentUser.local_id) && settingsAccess.status === 'error'
                ? <p role="alert">{settingsMessages.unavailable}</p> : <NoAuth />} />
             <Route path="/Integrations" element={isSuperAdmin() ? <Integrations /> : <NoAuth />} />
            <Route path="/ModificacionesPedidos" element={getPermissionState(70) ? <ModificacionesPedidos lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/CambiosPrecios" element={getPermissionState(70) ? <PriceModifications /> : <NoAuth />} />
            <Route path="/ReviewsSummary" element={isSuperAdmin() ? <ReviewsSummary lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/OnlineMenuManagement" element={getPermissionState(59) ? <OnlineMenuManagement /> : <NoAuth />} /> 
            <Route path="/Clients" element={true ? <Clients /> : <NoAuth />} />                            
            <Route path="/Compras" element={getPermissionState(76) ? <Gastos /> : <NoAuth />} />
            <Route path="/Salarios" element={getPermissionState(78) ? <Salario /> : <NoAuth />} />
            <Route path="/StorageUnits" element={getPermissionState(72) ? <StorageUnits /> : <NoAuth />} />
            <Route path="/Bills" element={getPermissionState(74) ? <Bills lastSession={lastSession} /> : <NoAuth />} />
            <Route path="/Stock" element={getPermissionState(14) ? <Stock lastSession={lastSession}/> : <NoAuth />} />
            <Route path="/Recommendations" element={<Recommendations />} />
            <Route path="/TipManagement" element={<TipManagement />} />


            {/* require pedidos context only for these three */}
            <Route element={<PedidosLayout />}>
              <Route path="/Restaurant" element={getPermissionState(82) ? <Restaurant /> : <NoAuth />} />
              <Route path="/Delivery" element={getPermissionState(81) ? <Delivery /> : <NoAuth />} />
              <Route path="/HistorialDePedidos" element={getPermissionState(52) ? <HistorialPedidos lastSession={lastSession} /> : <NoAuth />} />
              <Route path="/Receipts" element={getPermissionState(2) ? <ReceiptsDisplay lastSession={lastSession} /> : <NoAuth />} />
              <Route path="/PedidosConfig" element={ <PedidosConfig />} />
            </Route>

            <Route path="/ReservationManagement" element={getPermissionState(25) ? <ReservationManagement lastSession={lastSession} /> : <NoAuth />} />

            {/* admin only */}
            
            </Routes>
        </div>
      </div>
    </div>
    <Ciao />
    </>
  );
};

export default Base;
